import React from 'react'
import logo from '@/assets/common/logo.svg'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import device from '../lp/device'


interface HeaderProps {
    subContents?: React.ReactNode
}


const Header: React.FC<HeaderProps> = (props) => {
    const { subContents } = props;

    return (
        <Container>
            <Link to="/dashboard">
                <Logo>
                    <img src={logo} alt="logo" height="35px" />
                </Logo>
            </Link>
            {
                subContents &&
                 <>
                    <Spacer />
                    {subContents}
                 </>
            }
        </Container>
    )
}

export default Header

const Logo = styled.div`
    padding: ${p => p.theme.spaces.normal};

    @media ${device.mobile} {
        & > img {
            width: 120px;
        }
    }   
`;

const Container = styled.div`
    display: flex;
    height: 65px;
    width: 100%;
    justify-content: space-between;
    box-shadow: 0px 0px 2px 3px #eaeaea;
`

const Spacer = styled.div`
    flex-grow: 1;
`